module.exports = __webpack_public_path__ + "img/navigator_bar_handbook.3d73b0da.svg";